// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"a3b87ce5","198":"dba3eb0a","401":"4bb9455c","664":"375a7bcf","731":"27f95913","884":"d40c536b","948":"0c2c1053","986":"c3ee56c6"}[chunkId] + ".chunk.js";
};